import React from 'react';
import { Grid } from '@mui/material';
import { useFilters } from './FilterContext';
import { createFilter } from './FilterFactory';

export const FilterContainer = ({ filterTypes = null }) => {
  const { config: { filters } } = useFilters();

  // Create array of enabled filter types from config
  const enabledFilters = [];
  
  // Add filters based on config
  Object.entries(filters).forEach(([key, definition]) => {
    if (typeof definition === 'object') {
      const isEnabled = definition.enabled !== false;
      if (isEnabled) {
        enabledFilters.push(key);
      }
    } else if (definition) {
      enabledFilters.push(key);
    }
  });

  // Filter the enabled filters based on filterTypes prop
  const filteredTypes = React.useMemo(() => {
    if (!filterTypes) {
      // No filtering, return all enabled filters
      return enabledFilters;
    }

    const typesToShow = Array.isArray(filterTypes) ? filterTypes : [filterTypes];
    
    return enabledFilters.filter(filterKey => {
      return typesToShow.some(typeFilter => {
        // Exact match (e.g., 'dropdown.timeframe')
        if (filterKey === typeFilter) {
          return true;
        }
        
        // Type prefix match (e.g., 'dropdown' matches 'dropdown.timeframe')
        if (filterKey.startsWith(typeFilter + '.')) {
          return true;
        }
                
        return false;
      });
    });
  }, [enabledFilters, filterTypes]);

  return (
    <div>
      {/* Render dropdown filters in grid */}
      <Grid container spacing={3}>
        {filteredTypes.filter(filterType => filterType !== 'chips').map(filterType => createFilter(filterType))}
      </Grid>

      {/* Render chips filter separately (full width) */}
      {filteredTypes.includes('chips') && createFilter('chips')}
    </div>
  );
};
